import { render } from "./jin-header.vue?vue&type=template&id=165a7f1a&scoped=true"
import script from "./jin-header.vue?vue&type=script&lang=js"
export * from "./jin-header.vue?vue&type=script&lang=js"

import "./jin-header.vue?vue&type=style&index=0&id=165a7f1a&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-165a7f1a"]])

export default __exports__